import { atom } from "jotai";

export const isProcessingApplicationAtom = atom(false);
